
export default function DescriptionBanner({ title = 'Title', description = 'description' }) {



    return (
        <div className="w-full mx-auto flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-0 min-w-0">
            {/* Titolo */}
            <h1 className="text-xl sm:text-2xl font-semibold text-gray-800 sm:whitespace-nowrap sm:mr-4 flex-shrink-0">{title}</h1>

            {/* Descrizione */}
            <p className="text-sm sm:text-base text-gray-600 border-l-2 border-gray-400 pl-3 break-words min-w-0">
                {description}
            </p>
        </div>
    );
}
